import { Layout } from "../../layouts";
import { Row, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";

export const OrderConfirmationSkeleton = () => {
  return (
    <>
      <Layout className="order-confirmation-layout">
        <div className="order-confirmation-container">
          <Row>
            {/* Left Section */}
            <Col md={12} lg={7} xl={8}>
              {/* Header */}
              <div className="d-flex gap-3 mb-4">
                <Skeleton circle width={45} height={45} />
                <div className="flex-grow-1">
                  <Skeleton width="60%" height={30} />
                  <Skeleton width="90%" />
                  <Skeleton width="70%" />
                </div>
              </div>

              {/* Quick Actions */}
              <div className="confirmation-card mb-4 p-3">
                {[1, 2, 3, 4, 5].map((item) => (
                  <div key={item} className="d-flex align-items-center mb-4">
                    <Skeleton circle width={42} height={42} />
                    <div className="ms-3 flex-grow-1">
                      <Skeleton width="40%" />
                      <Skeleton width="70%" />
                    </div>
                  </div>
                ))}
              </div>

              {/* Order Status */}
              <div className="confirmation-card p-3">
                <div className="d-flex justify-content-between mb-4">
                  <Skeleton width={180} height={28} />
                  <Skeleton circle width={34} height={34} />
                </div>

                {[1, 2, 3, 4].map((item) => (
                  <div key={item} className="d-flex align-items-center mb-4">
                    <Skeleton circle width={24} height={24} />
                    <div className="ms-3 flex-grow-1">
                      <Skeleton width="30%" />
                      <Skeleton width="60%" />
                    </div>
                  </div>
                ))}
              </div>
            </Col>

            {/* Right Section */}
            <Col md={12} lg={5} xl={4}>
              {/* Loyalty Card */}
              <div className="confirmation-card mb-4 p-3">
                <Skeleton height={120} />
              </div>

              {/* Order Summary */}
              <div className="order-summary-card p-3">
                <Skeleton width={180} height={28} className="mb-4" />

                {[1, 2, 3].map((item) => (
                  <div
                    key={item}
                    className="d-flex justify-content-between mb-3"
                  >
                    <div className="flex-grow-1 me-3">
                      <Skeleton width="70%" />
                      <Skeleton width="45%" />
                    </div>
                    <Skeleton width={60} />
                  </div>
                ))}

                <Skeleton width={160} height={24} className="mt-4 mb-3" />

                {[1, 2, 3, 4].map((item) => (
                  <div
                    key={item}
                    className="d-flex justify-content-between mb-2"
                  >
                    <Skeleton width={120} />
                    <Skeleton width={70} />
                  </div>
                ))}

                <div className="mt-4">
                  <Skeleton width={120} />
                  <Skeleton width={100} />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Layout>
    </>
  );
};
